import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { AutomationStepEntity } from './automation-step.entity';
import { AutomationVersionEntity } from './automation-version.entity';
import { BaseEntity } from './base.entity';

@Entity('_automation_flow')
export class AutomationFlowEntity extends BaseEntity {
	@Column({ name: '_name', type: 'varchar', length: 255 })
	public name!: string;

	@Column({ name: '_description', type: 'text', nullable: true })
	public description?: string;

	@Column({
		name: '_system_slug',
		type: 'varchar',
		length: 100,
		unique: true,
		nullable: true,
	})
	public systemSlug?: string;

	@Column({ name: '_is_active', type: 'boolean', default: false })
	public isActive!: boolean;

	@Column({
		name: '_fk__automation_flow__id',
		type: 'int',
		nullable: true,
		unsigned: true,
	})
	public parentFlowId?: number;

	@Column({
		name: '_fk__active_automation_version__id',
		type: 'int',
		nullable: true,
		unsigned: true,
	})
	public activeVersionId?: number | null;

	@Column({
		name: '_fk__draft_automation_version__id',
		type: 'int',
		nullable: true,
		unsigned: true,
	})
	public draftVersionId?: number | null;

	@ManyToOne(() => AutomationFlowEntity, { nullable: true })
	@JoinColumn({ name: '_fk__automation_flow__id' })
	public parentFlow?: AutomationFlowEntity;

	@OneToMany(() => AutomationStepEntity, (step) => step.flow)
	public steps!: AutomationStepEntity[];

	@OneToMany(() => AutomationFlowEntity, (flow) => flow.parentFlow)
	public draftVersions!: AutomationFlowEntity[];

	@OneToMany(() => AutomationVersionEntity, (version) => version.flow)
	public versions!: AutomationVersionEntity[];

	@ManyToOne(() => AutomationVersionEntity, { nullable: true })
	@JoinColumn({ name: '_fk__active_automation_version__id' })
	public activeVersion?: AutomationVersionEntity;

	@ManyToOne(() => AutomationVersionEntity, { nullable: true })
	@JoinColumn({ name: '_fk__draft_automation_version__id' })
	public draftVersion?: AutomationVersionEntity;
}
